import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { copyObject } from 'src/modules/shared/utils/utility';
import {IPostHolderAddRequest, PostHolderAddRequest} from "../../../shared/interfaces/IPostHolderAddRequest";

@Component({
  selector: 'app-post-holders-details',
  templateUrl: './post-holders-details.component.html',
  styleUrls: ['./post-holders-details.component.css'],
})
export class PostHoldersDetailsComponent implements OnInit {
  private INITIAL_STATE: IPostHolderAddRequest = PostHolderAddRequest;

  @Input() Requests: IPostHolderAddRequest[] = [];
  @Input() readonly: boolean = false;
  @ViewChild('AddForm') addFormModel: NgForm;

  invalid: boolean = false;

  isEditMode = false;
  isAddingNewSystem = false;
  currentEditIndex = -1;
  currentRequests: IPostHolderAddRequest = this.getInitialState();

  constructor() {}

  ngOnInit(): void {
  }

  handleAddingNewRecordClick() {
    this.isAddingNewSystem = true;
  }

  onDelete(index: number) {
    if (this.Requests.length != 1) this.Requests.splice(index, 1);
    else if (this.Requests.length == 1 && index == 0) this.Requests.shift();
    this.resetComponent();
  }

  onEdit(index: number) {
    this.currentRequests = copyObject(this.Requests[index]);
    this.currentEditIndex = index;
    this.isAddingNewSystem = true;
    this.isEditMode = true;
  }

  onSave() {
    if (this.addFormModel.invalid) {
      this.invalid = true;
      return null;
    }
    if (this.isEditMode) {
      this.Requests[this.currentEditIndex] = this.currentRequests;
    } else {
      this.Requests.push(this.currentRequests);
    }
    this.resetComponent();
  }

  onCancel() {
    this.resetComponent();
  }

  private resetComponent() {
    this.currentRequests = this.getInitialState();
    this.isAddingNewSystem = false;
    this.isEditMode = false;
    this.currentEditIndex = -1;
  }

  getInitialState() {
    return copyObject(this.INITIAL_STATE);
  }
}
